const initState = {
    complianceStandards: [],
    compliance_id: null,
    compliance: null,
    procedures: [],
    actions: [],
    actionsScopeKey: null,
    newlyCreatedComplianceId: null,
    compliance_dashboard_data: null,
    activeComplianceId: null,
    actions_data: [],
    actionsDataScopeKey: null,
    actionsLoading: false,
    finding_data: [],
    findingsScopeKey: null,
    findingsLoading: false,
};

const complianceReducer = (state = initState, action) => {
    switch (action.type) {
        case "SET_ACTIVE_COMPLIANCE":
            ////////console.log("reducer action:",action);
            return {
                ...state,
                activeComplianceId: action.compliance_id,
            };

        case "OPEN_COMPLIANCE_DASHBOARD":
            return {
                ...state,
                compliance_dashboard_data: action.compliance_id,
            };

        case "RESET_COMPLIANCE_DASHBOARD":
            return {
                ...state,
                compliance_dashboard_data: null,
            };

        case "PROCEDURES":
            return {
                ...state,
                procedures: action.complianceStandards,
            };

        case "COMPLIANCE_ACTIONS_REQUEST": {
            const nextKey = `comp:${action.compliance_id ?? 0}`;
            const isScopeChange = nextKey !== state.actionsScopeKey;
            return {
                ...state,
                actions: isScopeChange ? [] : state.actions,
                actionsScopeKey: nextKey,
            };
        }

        case "COMPLIANCE_ACTIONS":
            if (
                action.scopeKey != null &&
                state.actionsScopeKey != null &&
                action.scopeKey !== state.actionsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                actions: action.actions,
                actionsScopeKey: action.scopeKey ?? state.actionsScopeKey,
            };

        case "UPDATE_COMPLIANCE_STANDARD":
            return {
                ...state,
                compliance: action.compliance,
            };

        case "RESET_NEWLYCREATED_COMPLIANCE_ID":
            return {
                ...state,
                newlyCreatedComplianceId: null,
            };

        case "COMPLIANCE_CREATED":
            ////console.log("Here")
            return {
                ...state,
                complianceStandards: action.complianceStandards,
                newlyCreatedComplianceId: action.newlyCreatedComplianceId,
            };

        case "COMPLIANCE_STANDARDS":
            ////console.log("Here 2 ", action.complianceStandards)
            return {
                ...state,
                complianceStandards: action.complianceStandards,
            };
            
         case "ACTIONS_DATA_COMP_REQUEST": {
            const nextKey = `comp:${action.compliance_id ?? 0}`;
            const isScopeChange = nextKey !== state.actionsDataScopeKey;
            return {
                ...state,
                actions_data: isScopeChange ? [] : state.actions_data,
                actionsDataScopeKey: nextKey,
                actionsLoading: true,
            };
        }

         case "ACTIONS_DATA_COMP":
            if (
                action.scopeKey != null &&
                state.actionsDataScopeKey != null &&
                action.scopeKey !== state.actionsDataScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                actions_data: action.actions,
                actionsDataScopeKey: action.scopeKey ?? state.actionsDataScopeKey,
                actionsLoading: false,
            };
        case "ACTIONS_DATA_COMP_FETCH_FAILED":
            return {
                ...state,
                actionsLoading: false,
            };

        case "COMPLIANCE_FINDINGS_REQUEST": {
            const nextKey = `comp:${action.compliance_id ?? 0}`;
            const isScopeChange = nextKey !== state.findingsScopeKey;
            return {
                ...state,
                finding_data: isScopeChange ? [] : state.finding_data,
                findingsScopeKey: nextKey,
                findingsLoading: true,
            };
        }

         case "COMPLIANCE_FINDINGS_DATA":
            if (
                action.scopeKey != null &&
                state.findingsScopeKey != null &&
                action.scopeKey !== state.findingsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                finding_data: action.findings,
                findingsScopeKey: action.scopeKey ?? state.findingsScopeKey,
                findingsLoading: false,
            };
        case "COMPLIANCE_FINDINGS_FETCH_FAILED":
            return {
                ...state,
                findingsLoading: false,
            };

        case "COMPLIANCE_STANDARD_DELETE":
            return {
                ...state,
                complianceStandards: state.complianceStandards.filter(
                    (c) => c.compliance_id !== action.id
                ),
                activeComplianceId: state.activeComplianceId === action.id? null : state.activeComplianceId
            };

        default:
            return state;
    }
};

export default complianceReducer;